import { I18nProvider } from '@lingui/react';
import log from 'loglevel';
import React from 'react';
import ReactDOM from 'react-dom';
import 'url-search-params-polyfill';
import { catalogs, defaultLanguageCountry } from './app.config';
import Callback from './components/Callback';
// import registerServiceWorker from './registerServiceWorker';

let languageCountry = defaultLanguageCountry;

log.info('languageCountry', languageCountry);

const params = new URLSearchParams(window.location.search);
if (typeof params !== 'undefined' || params !== '') {
  const dataValue = params.get('data');
  if (typeof dataValue !== 'undefined' && dataValue !== ''
    && dataValue !== null) {
    const data = window.atob(dataValue);
    if (typeof data !== 'undefined' && data !== '') {
      const dataObj = JSON.parse(data);
      log.debug('dataObj', dataObj);
      if (typeof dataObj.language !== 'undefined' && dataObj.language !== '') {
        try {
          languageCountry = dataObj.language;
        } catch {
          log.error('Unable to get country for', dataObj.language);
        }
      }
    }
  }
}

log.info('languageCountry updated', languageCountry);

/**
 * App wrapper for Callback.
 *
 * @returns { object } App
 */
const App = () => (
  <I18nProvider language={languageCountry} catalogs={catalogs}>
    <Callback />
  </I18nProvider>
);

ReactDOM.render(<App />, document.getElementById('root'));

/**
 * Register or unregister
 * turning off - causing cache issues in browser.
 */
// registerServiceWorker();
